module.exports = __webpack_public_path__ + "media/images/favicon-f6c2d3a9.png";